import LoggingActions from '../actions/LoggingActions'
import { ANALYTICS_CATEGORY } from '../constants/Constants'
/*
  TODO: use pcln-analytics to do GA click tracking...
 */
class TagManager {
  constructor () {
    this.tagQueue = []
    this.fireTagInterval = null
    this.fireQueuedTags = this.fireQueuedTags.bind(this)
  }

  fireQueuedTags () {
    if (window && window.dataLayer) {
      let tag = this.tagQueue.shift()
      while (tag) {
        window.dataLayer.push(tag)
        tag = this.tagQueue.shift()
      }
      window.clearInterval(this.fireTagInterval)
      this.fireTagInterval = null
      window.removeEventListener('unload', this.fireQueuedTags)
    }
  }

  fireTag (tag) {
    if (typeof window !== 'undefined') {
      try {
        if (this.fireTagInterval) {
          this.tagQueue.push(tag)
        } else {
          window.dataLayer.push(tag)
        }
      } catch (error) {
        this.tagQueue.push(tag)
        if (!this.fireTagInterval) {
          this.fireTagInterval = window.setInterval(this.fireQueuedTags, 1000)
          window.addEventListener('unload', this.fireQueuedTags)
        }
        LoggingActions.send('warning', {
          errorMessage: error.message,
          lineno: error.lineNumber,
          colnum: error.columnNumber
        })
      }
    }
  }
}

const TagMgr = new TagManager()

export function send ({
  event = 'gtm-custom-event',
  category = ANALYTICS_CATEGORY,
  action,
  data
}) {
  TagMgr.fireTag({
    event,
    'gtm-event-category': category,
    'gtm-event-action': action,
    'gtm-event-label': data
  })
}

export function sendSetiGA (teamName, dimension, testName, testVariant) {
  const testVariantToken = `${testName}|${testVariant || 'NOT_FOUND'}`
  const tag = {
    event: 'seti',
    seti_team_name: teamName
  }

  tag[dimension] = testVariantToken
  TagMgr.fireTag(tag)
}
